import React, { useState } from 'react';
import TauriSectionBaseVisual from '../../TauriSectionBaseVisual/TauriSectionBaseVisual';
import config from '../../../config.json';
import './TauriHostSection.css';

const TauriHostSection = ({ section, palettes, themes }) => {
  const [isHoveringChartContent, setIsHoveringChartContent] = useState(false);

  let height = config.hostSectionHeight * section.rows;
  let addSpacing = section.rows > 1 ? (section.rows - 1) * 0.9375 : 0; //The 0.9375 is the 0.9375rem gap of grid
  return (
    <div
      className={`host-section ${isHoveringChartContent ? 'show-toolbar' : 'hide-toolbar'}`}
      style={{
        height: `${height + addSpacing}rem`,
        padding: '0.9375rem',
        display: 'flex',
        justifyContent: 'center'
      }}
      onMouseEnter={() => setIsHoveringChartContent(true)}
      onMouseLeave={() => setIsHoveringChartContent(false)}>
      <div className='section-visual' style={{ width: '100%' }}>
        <TauriSectionBaseVisual visual={section.visual} columnSize={section.columns} rowSize={section.rows} palettes={palettes} themes={themes} isModal={false} />
      </div>
    </div>
  );
};

export default TauriHostSection;